import React from 'react';

import InlineCode from '~/components/InlineCode.react';
import SectionCode from '~/components/SectionCode.react';
import SectionDescription from '~/components/SectionDescription.react';
import SectionExample from '~/components/SectionExample.react';
import SectionTitle from '~/components/SectionTitle.react';

import PopoverTop from '~/pages/components/popovers/PopoverTop.react';
import ErrorPopover from '~/pages/components/popovers/ErrorPopover.react';
import DarkPopover from '~/pages/components/popovers/DarkPopover.react';

import { popoverStyles } from '~/components/CodeSnippets.js';

export default function PopoverStyles() {
    return (
        <section className="marginBottom-xl">
            <div className="marginBottom-m breakPointM-marginBottom-l">
                <SectionTitle sectionTitle={"Popover styles"} />

                <SectionDescription>
                    There are three popover styles: default, error and dark.
                    Apply <InlineCode>.popover--default</InlineCode>,{" "}
                    <InlineCode>.popover--error</InlineCode> and {" "}
                    <InlineCode>.popover--dark</InlineCode> accordingly.
                </SectionDescription>
            </div>

            <SectionExample>
                <div className="grid grid--1 breakPointM-grid--3">
                    <div className="padding-m textAlign-center borderStyle-solid borderColor-smoke borderWidth-0 borderBottomWidth-1 breakPointM-borderRightWidth-1 breakPointL-borderBottomWidth-0">
                        <div className="marginTop-xs marginBottom-s">
                            <PopoverTop />
                        </div>

                        <p className="lineHeight-s fontSize-s fontWeight-3 c-silver">Default popover</p>
                    </div>

                    <div className="padding-m textAlign-center borderStyle-solid borderColor-smoke borderWidth-0 borderBottomWidth-1 breakPointL-borderBottomWidth-0 breakPointL-borderRightWidth-1">
                        <div className="marginTop-xs marginBottom-s">
                            <ErrorPopover />
                        </div>

                        <p className="lineHeight-s fontSize-s fontWeight-3 c-silver">Error popover</p>
                    </div>

                    <div className="padding-m textAlign-center borderStyle-solid borderColor-smoke borderWidth-0 borderBottomWidth-1 breakPointM-borderBottomWidth-0 breakPointM-borderRightWidth-1">
                        <div className="marginTop-xs marginBottom-s">
                            <DarkPopover />
                        </div>

                        <p className="lineHeight-s fontSize-s fontWeight-3 c-silver">Dark popover</p>
                    </div>
                </div>
            </SectionExample>

            <SectionCode codeType="language-html" code={popoverStyles} />
        </section>
    );
}



/** WEBPACK FOOTER **
 ** ./src/site/js/pages/components/popovers/PopoverStyles.react.js
 **/